import React from "react";

export default function FullScreenLoading({ text = "Đang tải dữ liệu..." }) {
  return (
    <div className="dealer-loading-overlay">
      <div className="dealer-loading-box">
        <div className="dealer-loading-spinner" />
        <div>{text}</div>
      </div>
    </div>
  );
}
